
import axios from 'axios';
import { getSocket } from '../socket';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Log the baseURL for debugging
console.log('🔍 API baseURL:', api.defaults.baseURL);

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('token');
  if (token) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  // Attach Socket.IO socket ID if available
  try {
    const socket = getSocket();
    if (socket && socket.id) {
      config.headers['x-socket-id'] = socket.id;
    }
  } catch (e) {
    // ignore if socket not ready
  }
  // Log all API requests
  const logData = config.method?.toUpperCase() === 'GET' ? config.params : config.data;
  console.log('🔍 API Request:', config.method?.toUpperCase(), config.url, logData);
  return config;
});

// Log all API responses
api.interceptors.response.use(
  (response) => {
    console.log('🔍 API Response:', response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error('🔍 API Error:', error.response?.status, error.config?.url, error.message);
    return Promise.reject(error);
  }
);

export default api;
